import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Fade, Skeleton } from '@mui/material';
import { AnimatePresence, domAnimation, LazyMotion, m } from 'framer-motion';
import { memo, useMemo } from 'react';
import { SkeletonPanel } from './panel';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
const transition = {
    duration: 0.3,
};
const tab_variants = {
    initial: {
        opacity: [0.5, 1],
    },
    hide: {
        opacity: 0.2,
    },
    show: {
        opacity: 1,
    },
};
const style = {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    // display: 'flex',
    // flexDirection: 'column',
};
export const TabSkeleton = memo(function TabSkeleton(props) {
    const { is_loaded, children, tabKey } = props;
    const skeleton = useMemo(() => {
        if (tabKey == DefaultTabKey.graphs) {
            return (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 40 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 300 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 300 })] }));
        }
        if (tabKey == DefaultTabKey.eventsTab) {
            return (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 40 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 70 })] }));
        }
        if (tabKey == DefaultTabKey.cams) {
            return (_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 240 }));
        }
        if (tabKey == 'blockly') {
            return (_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 240 }));
        }
        if (tabKey == DefaultTabKey.vehicle_tab) {
            return (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 250 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", height: 150, width: 300 }), _jsxs(Box, { display: "flex", flexDirection: "column", width: "100%", rowGap: 2, children: [_jsx(SkeletonPanel, { size: 3 }), _jsx(SkeletonPanel, { size: 3 })] })] }));
        }
        if (tabKey == DefaultTabKey.map) {
            return (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 40 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 600 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 300 })] }));
        }
        if (tabKey.includes(DefaultTabKey.dashboard)) {
            return (_jsxs(Box, { display: "grid", gridTemplateColumns: isMediumUI() ? 'repeat(2, 1fr)' : '1fr', width: "100%", height: "100%", py: 1, gap: 2, children: [_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 400 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 400 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 400 }), _jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 400 })] }));
        }
        return (_jsxs(_Fragment, { children: [_jsx(SkeletonPanel, { size: 7 }), _jsx(SkeletonPanel, { size: 3 }), _jsx(SkeletonPanel, { size: 0 })] }));
    }, [tabKey]);
    return (_jsx(AnimatePresence, { exitBeforeEnter: true, children: _jsx(LazyMotion, { features: domAnimation, children: is_loaded ? (_jsx(m.div, { variants: tab_variants, initial: "initial", animate: "show", exit: "hide", style: style, transition: transition, children: children })) : (_jsx(Fade, { in: !is_loaded, children: _jsx(Box, { display: "flex", flexDirection: "column", width: "100%", height: "300px", gap: 2, p: 2, overflow: "hidden", alignItems: "center", children: skeleton }) })) }) }));
});
